import msalConfiguration from 'hybridspace-common/lib/constants/msalConfiguration';
import { logAppBootStep } from 'hybridspace-telemetry/lib/logAppBootStep';
import logUserSessionFromMetaOSContext from 'hybridspace-telemetry/lib/utils/logUserSessionFromMetaOSContext';
import { PassiveMonitoringAriaTenantToken } from 'owa-analytics-start';
import { loadDataWorker } from 'owa-data-worker-loader';
import { start } from 'owa-start';
import { lazyBootstrap } from './lazyBootFunctions';
import { onFatalBootError } from './onFatalBootError';
import { overrideBootPromises } from './overrideBootPromises';

// TODO: Consider making this be lazy-loaded
// Currently, the `hybridspace-telemetry` package is being bundled in the `placesindex` bundle
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function logAppBootStep called at module scope is not allowed. This may cause unwanted side effects. */
logAppBootStep('AppStart');

const app = 'Places';

let metaOSContext: { userId?: string; tenantId?: string } | undefined;

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function start called at module scope is not allowed. This may cause unwanted side effects. */
start({
    app,
    loadBpos: true,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function PassiveMonitoringAriaTenantToken called at module scope is not allowed. This may cause unwanted side effects. */
    startupAriaToken: PassiveMonitoringAriaTenantToken(), // OWA Passive Monitoring
    msalConfiguration,
    runAfterMetaOsAppInitialized: (
        _metaOsHostName,
        _metaOsHostClientType,
        metaOsUserId,
        metaOsTenantId,
        _metaOsHostSessionId
    ) => {
        metaOSContext = { userId: metaOsUserId, tenantId: metaOsTenantId };
        logUserSessionFromMetaOSContext('Start');
    },
    runBeforeStart: async () => {
        try {
            loadDataWorker();
        } catch {
            // do not break boot for data worker load failure
        }
    },
    bootstrap: lazyBootstrap,
    onFatalBootError,
    overrideBootPromises: authToken => {
        return overrideBootPromises(app, authToken, metaOSContext?.userId, metaOSContext?.tenantId);
    },
});
